import { useRef, useState } from "react";
import { ActionButton } from "../common";

const coordinate = (event) => {
  const bounds = event.currentTarget.getBoundingClientRect();
  return { x: Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width)), y: Math.max(0, Math.min(1, (event.clientY - bounds.top) / bounds.height)) };
};
const path = (stroke) => stroke.map((point, index) => `${index ? "L" : "M"}${point.x * 600},${point.y * 180}`).join(" ");

export const SignaturePad = ({ strokes = [], onChange, disabled, prefix }) => {
  const [draft, setDraft] = useState([]);
  const current = useRef(null);
  const total = strokes.reduce((count, stroke) => count + stroke.length, 0);
  const start = (event) => {
    if (disabled || strokes.length >= 40 || total >= 4000 || (event.pointerType === "mouse" && event.button !== 0)) return;
    event.preventDefault(); event.currentTarget.setPointerCapture(event.pointerId);
    current.current = { pointer: event.pointerId, points: [coordinate(event)] }; setDraft(current.current.points);
  };
  const move = (event) => {
    if (!current.current || current.current.pointer !== event.pointerId || disabled || current.current.points.length >= Math.min(500, 4000 - total)) return;
    current.current.points = [...current.current.points, coordinate(event)]; setDraft(current.current.points);
  };
  const end = (event) => {
    if (!current.current || current.current.pointer !== event.pointerId) return;
    const points = current.current.points; current.current = null; setDraft([]);
    if (!disabled && points.length > 1) onChange([...strokes, points]);
  };
  return <div className="space-y-2">
    <p className="text-xs text-slate-500" data-testid={`${prefix}-signature-help`}>Hand-drawn signature (optional). Draw with your mouse or finger; the typed name and certification below are still required.</p>
    <svg data-testid={`${prefix}-signature-pad`} aria-label="Optional hand-drawn inspector signature" role="img" viewBox="0 0 600 180" preserveAspectRatio="none"
      className={`w-full h-36 rounded-xl border border-slate-300 bg-slate-50 ${disabled ? "" : "touch-none cursor-crosshair"}`}
      onPointerDown={start} onPointerMove={move} onPointerUp={end} onPointerCancel={() => { current.current = null; setDraft([]); }}>
      <line x1="20" y1="145" x2="580" y2="145" stroke="#cbd5e1" strokeDasharray="4 4" />
      {strokes.filter((stroke) => stroke.length).map((stroke, index) => <path key={`stroke-${index}`} d={path(stroke)} fill="none" stroke="#1e293b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />)}
      {draft.length > 0 && <path key="draft" d={path(draft)} fill="none" stroke="#1e293b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />}
    </svg>
    <div className="flex flex-wrap gap-2">
      <ActionButton type="button" testId={`${prefix}-signature-undo`} variant="secondary" disabled={disabled || !strokes.length} onClick={() => onChange(strokes.slice(0, -1))}>Undo Stroke</ActionButton>
      <ActionButton type="button" testId={`${prefix}-signature-clear`} variant="secondary" disabled={disabled || !strokes.length} onClick={() => onChange([])}>Clear Signature</ActionButton>
    </div>
    {(strokes.length >= 40 || total >= 4000) && <p role="status" data-testid={`${prefix}-signature-limit`} className="text-xs text-amber-800">Signature limit reached. Undo or clear to draw again.</p>}
  </div>;
};
